export enum PlaybackType {
	HLS = 'HLS',
	DASH = 'DASH',
}
